import React from 'react';

const SuggestionDropdown = ({ data = [], loading, error, onSelect }) => {
  if (!loading && !error && data.length === 0) return null;

  return (
    <div className="absolute top-full left-0 right-0 mt-1 z-50">
      <div className="bg-white border border-gray-300 rounded shadow text-sm">
        {loading && (
          <div className="px-4 py-2 text-gray-500">Loading...</div>
        )}

        {error && (
          <div className="px-4 py-2 text-red-500">Error: {error}</div>
        )}

        {!loading && !error && data.map((item) => (
          <div
            key={item.placeId}
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-800"
            onClick={() => onSelect(item)}
          >
            {item.description}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuggestionDropdown;
